import { EventAction } from './events/actions';
import { EventCategory } from './events/categories';
import {
  MobilePageViewCustomDimensionId,
  WebPageViewCustomDimensionId,
} from './events/customDimensions';
import { EventNames } from './events/names';

export const Tracker = {
  Action: EventAction,
  Category: EventCategory,
  Name: EventNames,
  MobilePageViewCustomDimensionId,
  WebPageViewCustomDimensionId,
};

export {
  EventAction as TrackingEventAction,
  EventCategory as TrackingEventCategory,
  EventNames as TrackingEventNames,
  MobilePageViewCustomDimensionId as TrackingMobilePageViewCustomDimensionId,
  WebPageViewCustomDimensionId as TrackingWebPageViewCustomDimensionId,
};
